
					const modules = import.meta.glob([
  "/src/mock/app.ts",
  "/src/mock/config_eventNotice.ts",
  "/src/mock/finance_clientInvoice.ts",
  "/src/mock/finance_employeesFinanceLogs.ts",
  "/src/mock/finance_pMSettlement.ts",
  "/src/mock/finance_supplierFinanceLogs.ts",
  "/src/mock/finance_supplierSettlement.ts",
  "/src/mock/organizational_commission.ts",
  "/src/mock/otherFunctions_articles.ts",
  "/src/mock/otherFunctions_queryIP.ts",
  "/src/mock/otherFunctions_sendMessages.ts",
  "/src/mock/project_projectRecord.ts",
  "/src/mock/project_projectSchedule.ts",
  "/src/mock/project_projectSettled.ts",
  "/src/mock/project_scheduling.ts",
  "/src/mock/record_callbackRecord.ts",
  "/src/mock/record_operationLogs.ts",
  "/src/mock/record_terminationRecord.ts",
  "/src/mock/supplier_tenantUser.ts",
  "/src/mock/user.ts"
], { eager: true });
					const fakeModuleList = Object.keys(modules).reduce((list, key) => {
						const module = modules[key] ?? {};
						if (module.default) {
							for (const moduleKey of Object.keys(module)) {
								const mod = modules[key][moduleKey] ?? [];
								const modList = Array.isArray(mod) ? [...mod] : [mod];
								return [...list, ...modList];
							}
						} else {
							return list;
						}
					}, []);
					window.__VITE__PLUGIN__FAKE__SERVER__.fakeModuleList = fakeModuleList;
				